import {
  type CreateCustomerGroupV1Dto,
  CustomerGroupsService,
  type CustomerGroupV1Dto,
  type PatchCustomerGroupV1Dto,
} from '@/openapi';
import { eventBus } from '@/configs/eventBus';

import type { CustomerGroupSimple } from '../customerGroupTypes';

export function useCustomerGroups() {
  const fetchCustomerGroup = async (id: string) => {
    try {
      return await CustomerGroupsService.customerGroupControllerV1FindOneV1(id);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCustomerGroups = async () => {
    try {
      return await CustomerGroupsService.customerGroupControllerV1FindAllV1();
    } catch (err) {
      console.log(err);
    }
  };

  const createCustomerGroup = async (data: CreateCustomerGroupV1Dto) => {
    try {
      await CustomerGroupsService.customerGroupControllerV1CreateV1(data);
      eventBus.emit('create');
    } catch (err) {
      console.log(err);
    }
  };

  const updateCustomerGroup = async (id: string, data: PatchCustomerGroupV1Dto) => {
    try {
      await CustomerGroupsService.customerGroupControllerV1UpdatePartialV1(id, data);
      eventBus.emit('update');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomerGroup = async (id: string) => {
    try {
      await CustomerGroupsService.customerGroupControllerV1RemoveOneV1(id);
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCustomerGroups = async (ids: string[]) => {
    try {
      await CustomerGroupsService.customerGroupControllerV1RemoveManyV1({
        values: ids,
      });
      eventBus.emit('delete');
    } catch (err) {
      console.log(err);
    }
  };

  return {
    fetchCustomerGroup,
    fetchCustomerGroups,
    createCustomerGroup,
    updateCustomerGroup,
    deleteCustomerGroup,
    deleteCustomerGroups,
  };
}

export function useCustomerGroupsConverter() {
  const convertCustomerGroupDtoToCustomerGroupSimple = (
    item: CustomerGroupV1Dto,
  ): CustomerGroupSimple => {
    const { createdAt: _createdAt, modifiedAt: _modifiedAt, customers: _customers, ...res } = item;
    return { ...res, customerCount: item.customers ? item.customers.length : 0 };
  };

  const convertCustomerGroupDtoListToCustomerGroupSimpleList = (
    data: CustomerGroupV1Dto[],
  ): CustomerGroupSimple[] => {
    return data.map((item) => {
      return convertCustomerGroupDtoToCustomerGroupSimple(item);
    });
  };

  const convertCustomerGroupSimpleToCreateCustomerGroupDto = (
    data: CustomerGroupSimple,
  ): CreateCustomerGroupV1Dto => {
    const { id: _id, version: _version, customerCount: _customerCount, ...res } = data;
    return res;
  };

  const convertCustomerGroupSimpleToUpdateCustomerGroupDto = (
    data: CustomerGroupSimple,
  ): PatchCustomerGroupV1Dto => {
    const { id: _id, customerCount: _customerCount, ...res } = data;
    return res;
  };

  return {
    convertCustomerGroupDtoToCustomerGroupSimple,
    convertCustomerGroupDtoListToCustomerGroupSimpleList,
    convertCustomerGroupSimpleToCreateCustomerGroupDto,
    convertCustomerGroupSimpleToUpdateCustomerGroupDto,
  };
}
